export default __webpack_public_path__ + "static/media/icon-spoa.b4e63140.svg";